import '../tables/Table.module.css'

function ObjectiveTableValidation(props) {

    function ScoringWeightsTable(inputHandler){
        let colGroup = (<>
            <colgroup>
                    <col style={{minWidth:'100px'}} />
                    <col style={{width:'150px'}} />
            </colgroup> 
        </>);

        const colNames =  ['Sub-Score', 'Scoring Weight'];   
        let tableHead = (
            <>
                <tr style={{fontSize: '14px'}}>
                    {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
                </tr>
            </>);

        let tableRows = (<></>);
        tableRows = props.objectives.map((objective, id) => {
            if (objective.is_score){
                return(
                    <tr key={`row_${id}`}>
                        <td key={`name_${id}`}>
                            <div style={{ fontSize: '14px' }}>
                                {objective.name}
                            </div>
                        </td>
                        <td key={`weight_${id}`}>
                                <input 
                                    id={`scoring_weight_${id}`}
                                    type='number' 
                                    placeholder='value' 
                                    autoComplete='false' 
                                    value={objective.scoring_weight} 
                                    onChange={inputHandler}
                                    style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'50px'}}/>
                        </td>
                    </tr>);
            }
        });
        return(<>
            <table style={{ tableLayout: 'auto' , width:'fit-content'}}>
            {colGroup}
                <thead >
                    {tableHead}
                </thead>
                <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
                <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                    {tableRows}
                </tbody>
            </table>
        </>
        );
    }

    /// ---------


    const colNames =  ['invalid sub-score', 'validation error', 'please correct'];  
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);

    let tableRows = [];
    const unvalidated_scores = props.validationMessage.unvalidated;
    const undefined_weights = props.validationMessage.undefined_weights;
    
    unvalidated_scores.forEach( (score, id) => {
        let button = (<> 
            <button 
                id={`objective_validation_${score.objective_id}`}
                // className={'actionButtonTiny'}
                className={'cellButton'}
                style={{marginTop:'3px', marginBottom:'3px'}}
                onClick={props.handleValidation}>
                validate
            </button></>);
        if (score.validation_error === 'expect at least 1x response to be a Sub-Score') {
            button = (<> 
                <button 
                    id={`objective_validation_${score.objective_id}`}
                    // className={'actionButtonTiny'}
                    className={'cellButton'}
                    style={{width:'110px', marginTop:'3px', marginBottom:'3px'}}
                    onClick={props.toEditor}>
                    add Sub-Score
                </button></>);
        }
 

        tableRows.push(
            <>
            <tr key={`row_${score.objective_id}`} style={{ marginBottom: '20px' }}>
                <td key={`field_name_${score.objective_id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}>
                        {score.name}
                    </div>
                </td>
                <td key={`error_msg_${score.objective_id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px', color: 'red' }}>
                        {score.validation_error}
                    </div>
                </td>
                <td key={`objective_validation_${score.objective_id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {button}
                    </div>
                </td>
            </tr>
            <tr><div style={{height:'10px'}}></div></tr>
            </>
            );
        });


    if(undefined_weights.length>0){
        tableRows.push(
            <>
            <tr key={`row`} style={{ marginBottom: '20px' }}>
                <td key={`field_name`} style={{verticalAlign: 'top'}}>
                    { undefined_weights.map( (score, id) => (
                        <>
                            <div style={{ fontSize: '14px' }}>
                                {score.name}
                            </div>
                        </>)) }
                </td>
                <td key={`error_msg`} style={{verticalAlign: 'top'}}>
                { undefined_weights.map( (score, id) => (
                        <>
                            <div style={{ fontSize: '14px', color: 'red' }}>
                                {score.validation_error}
                            </div>
                        </>)) }
                </td>
                <td key={`correct`} style={{verticalAlign: 'top'}}>
                    <div style={{margin:'0px', padding:'0px'}}>
                    {ScoringWeightsTable(props.inputHandler)}
                    </div>
                </td>
            </tr>
            <tr><div style={{height:'10px'}}></div></tr>
            </>
        );
    }


    return(<>
        <table style={{ tableLayout: 'auto' }}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default ObjectiveTableValidation;
